module.exports = __webpack_public_path__ + "fonts/OpenSansCondensed-Bold.cfd3dce5.ttf";